import { render, staticRenderFns } from "./Divergence.vue?vue&type=template&id=79c731ac"
import script from "./Divergence.vue?vue&type=script&lang=js"
export * from "./Divergence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports